import navbar from "./US/navbar";
import header from "./US/header";

export default {
  ...navbar,
  ...header
};
